import { GET_TRUSTED_EMPLOYER_ITEMS_LIST } from "../actions/TrustedEmployerActions";

const initialState = {
    trustedEmployerItemsList: [],
};

const TrustedEmployerReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_TRUSTED_EMPLOYER_ITEMS_LIST: {
            return {
                ...state,
                trustedEmployerItemsList: [...action.data]
            };
        }
        // case ACTION_ERROR: {
        //     return {
        //         ...state,
        //         failed: true,
        //         success: false,
        //         loading: false,
        //         showAlert: true,
        //         alertMessage: action.data,
        //     };
        // }
        default: {
            return state;
        }
    }
};

export default TrustedEmployerReducer;
